function waitForPuzzleInCart(dogId) {
  waitForElm('a[href="https://thepawprint.store/products/300pc-jigsaw-puzzle"]').then(() => {
    const aTag = document.querySelector('a[href="https://thepawprint.store/products/300pc-jigsaw-puzzle"]');
    const puzzleImageElement = aTag.parentElement.parentElement.parentElement.children[0];

    const puzzleImageUrl = `https://res.cloudinary.com/da9yd4bgx/image/fetch/t_puzzle-v1/${encodeURIComponent(imageUrl)}`;

    isImageUrlValid(puzzleImageUrl, function (isValid) {
      if (isValid) {
        puzzleImageElement.style.backgroundImage = 'url("' + puzzleImageUrl + '")';
      }
    });
  });
}

function waitForPuzzleInCartAlt(dogId) {
  waitForElm('div[data-variant-id="41146709508159"] .mu-item-image').then(() => {
    const puzzleImageElement = document.querySelector('div[data-variant-id="41146709508159"] .mu-item-image');

    const puzzleImageUrl = `https://res.cloudinary.com/da9yd4bgx/image/fetch/t_puzzle-v1/${encodeURIComponent(imageUrl)}`;

    isImageUrlValid(puzzleImageUrl, function (isValid) {
      if (isValid) {
        puzzleImageElement.style.backgroundImage = 'url("' + puzzleImageUrl + '")';
      }
    });
  });
}

function waitForCartTrashClick(dogId) {
  waitForElm('button[aria-label="remove item from cart"]').then(() => {
    const trashButtons = document.querySelectorAll('button[aria-label="remove item from cart"]');

    try {
      trashButtons.forEach(trashButton => {
        if (trashButton?.parentElement?.parentElement?.parentElement?.children[0]?.children[0]?.innerHTML?.toLowerCase()?.includes("puzzle")) {
          trashButton.addEventListener('click', () => {
            setTimeout(() => {
              waitForPuzzleInCart(dogId);
              waitForCartBumperClick(dogId);
              waitForCartDetailsClick(dogId);
            }, 600);
          });
        }
      });
    } catch (error) {
      console.log(error);
    }
  });
}

function waitForCartBumperClick(dogId) {
  waitForElm('.mu-fbt-item-atc').then(() => {
    const puzzleBumperButton = document.querySelector(".mu-fbt-item-atc");

    try {
      puzzleBumperButton.addEventListener('click', () => {
        setTimeout(() => {
          waitForPuzzleInCartAlt(dogId);
          waitForCartTrashClick(dogId);
        }, 600);
      });
    } catch (error) {
      console.log(error);
    }
  });
}

function waitForCartDetailsClick(dogId) {
  waitForElm('.mu-fbt-item-link.mu-btn-link').then(() => {
    const puzzleDetailsButtons = document.querySelectorAll(".mu-fbt-item-link.mu-btn-link");

    puzzleDetailsButtons.forEach(puzzleDetailsButton => {
      try {
        puzzleDetailsButton.addEventListener('click', () => {
          setTimeout(() => {
            waitForCartBumperDetails(dogId);
          }, 600);
        });
      } catch (error) {
        console.log(error);
      }
    });
  });
}

function waitForCartBumperDetails(dogId) {
  waitForElm('#monster_product_details').then(() => {
    const detailsDiv = document.querySelector('#monster_product_details');

    if (detailsDiv.innerHTML.includes("Puzzle")) {
      const puzzleImageElement = detailsDiv.children[0].children[0];

      const puzzleImageUrl = `https://res.cloudinary.com/da9yd4bgx/image/fetch/t_puzzle-v1/${encodeURIComponent(imageUrl)}`;

      isImageUrlValid(puzzleImageUrl, function (isValid) {
        if (isValid) {
          puzzleImageElement.src = puzzleImageUrl;
        }
      });
    }
  });
}

function waitForPersonalizedPuzzleCrossSell(dogId) {
  waitForElm('#product-personalized-puzzle').then(() => {
    const personalizedPuzzleDiv = document.querySelector('#product-personalized-puzzle');

    if (personalizedPuzzleDiv) {
      const containerDiv = document.querySelector(".action-upsell-popup");
      const imgDiv = document.querySelector(".image.upline");
      const imgTag = document.querySelector(".image.upline img");
      const actionPopupDesc = containerDiv.querySelector('.actionpopup_desc');

      actionPopupDesc.parentNode.insertBefore(imgDiv, actionPopupDesc.nextSibling);
      containerDiv.classList.add("puzzle-popup");
      imgTag.classList.add('cross-sell-img');

      const puzzleImageUrl = `https://res.cloudinary.com/da9yd4bgx/image/fetch/t_puzzle-v1/${encodeURIComponent(imageUrl)}`;

      isImageUrlValid(puzzleImageUrl, function (isValid) {
        if (isValid) {
          imgTag.src = puzzleImageUrl;
        }
      });
    }
  });
}

function waitForVipOffer() {
  if (window.OFFER_TYPES && window.offerType == window.OFFER_TYPES.NEW_CALENDAR) {
    waitForElm(".candyrack-ppp-checkbox-layout__info").then(() => {
      try {
        window.vipOfferLoaded = true;

        if (window.submissionLoaded) {
          setupVipOffer();
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
}

function initializeWaitForElmHandlers(dogId) {
  waitForShipProtectButton();

  if (!dogId) {
    return;
  }

  waitForCartDetailsClick(dogId);
  waitForPuzzleInCart(dogId);
  waitForPuzzleInCartAlt(dogId);
  waitForCartTrashClick(dogId);
  waitForCartBumperClick(dogId);
  waitForVipOffer();
  waitForPersonalizedPuzzleCrossSell(dogId);
}
